import { Instagram, Facebook } from "lucide-react";
import LogoMark from "@/components/LogoMark";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-black pb-10 pt-24"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <div className="grid gap-16 md:grid-cols-[2fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-5">
              <LogoMark size={96} />
              <div className="font-oswald text-6xl uppercase leading-none tracking-tight text-white md:text-[6vw]">
                JLP
              </div>
            </div>
            <div className="mt-6 font-editorial text-lg italic text-white/70 md:text-2xl">
              Fixing homes. Building dreams.
            </div>
            <div className="mt-6 max-w-sm text-sm text-white/50">
              JLP Construct & Repair LLC — a Pennsylvania-based full-service
              construction firm. Licensed. Insured. Answering the phone.
            </div>
          </div>

          <FooterCol
            title="Services"
            items={[
              "Handyman & Repairs",
              "Residential Builds",
              "Commercial Fit-outs",
              "24/7 Emergency",
            ]}
          />
          <FooterCol
            title="Contact"
            items={[
              { l: "610-349-7313", href: "tel:6103497313" },
              { l: "info@jlp-builds.com", href: "mailto:info@jlp-builds.com" },
              { l: "jlp-builds.com", href: "#" },
              { l: "Pennsylvania, USA", href: "#" },
            ]}
          />
          <FooterCol
            title="Site"
            items={[
              { l: "Services", href: "#services" },
              { l: "Manifesto", href: "#manifesto" },
              { l: "Work", href: "#work" },
              { l: "Estimate", href: "#estimate" },
            ]}
          />
        </div>

        <div className="mt-24 flex flex-col items-start justify-between gap-6 border-t border-white/10 pt-8 md:flex-row md:items-center">
          <div className="font-mono text-[11px] uppercase tracking-widest text-white/40">
            © {new Date().getFullYear()} JLP Construct & Repair LLC · All rights
            reserved
          </div>
          <div className="flex items-center gap-4">
            <a
              href="#"
              aria-label="Instagram"
              className="grid h-10 w-10 place-items-center border border-white/10 text-white/70 transition hover:border-white/40 hover:text-white"
            >
              <Instagram size={16} />
            </a>
            <a
              href="#"
              aria-label="Facebook"
              className="grid h-10 w-10 place-items-center border border-white/10 text-white/70 transition hover:border-white/40 hover:text-white"
            >
              <Facebook size={16} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/40">
        {title}
      </div>
      <ul className="mt-4 space-y-2">
        {items.map((i, k) => {
          const item = typeof i === "string" ? { l: i } : i;
          return (
            <li key={k}>
              {item.href ? (
                <a
                  href={item.href}
                  className="font-oswald text-lg uppercase tracking-tight text-white/85 transition hover:text-white"
                >
                  {item.l}
                </a>
              ) : (
                <span className="font-oswald text-lg uppercase tracking-tight text-white/85">
                  {item.l}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
